module.exports = __webpack_public_path__ + "img/5.23c98935.png";